/** Full Spanish label for a player role (e.g. "DEFENSA" -> "Defensa"). */
export function toFullRoleLabel(role?: string | null): string {
  const normalized = (role ?? '').trim().toUpperCase();

  switch (normalized) {
    case 'PORTERO':
      return 'Portero';
    case 'DEFENSA':
      return 'Defensa';
    case 'CENTROCAMPISTA':
      return 'Centrocampista';
    case 'DELANTERO':
      return 'Delantero';
    default:
      return '-';
  }
}
